interface RankProgressProps {
    percent?: number;
    pointTotal?: number;
    level: string;
    nextLevel?: string;
    levelImage?: string;
    nextLevelImage?: string;
}

export default function RankProgress({ percent = 0, pointTotal = 0, level = "", nextLevel = "", levelImage = "", nextLevelImage = "" }: RankProgressProps) {
    const clampedPercent = Math.max(0, Math.min(100, Number(percent || 0)));
    const progressTransform = `translateX(-${100 - clampedPercent}%)`;
    const markerLeft = `${clampedPercent}%`;

    return (
        <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
            <div
                className="MuiGrid-root MuiGrid-container MuiGrid-item"
                style={{ marginTop: "21.5px" }}
            >
                {/* LEFT RANK */}
                <div className="MuiGrid-root styles_progressRank_left__cWDx0 MuiGrid-item MuiGrid-grid-md-2">
                    <div className="flex justify-center">
                        <img
                            alt="icon rank"
                            src={levelImage || "https://cdn-web-next.thuocsi.vn/images/userLoyalty/rank_silver_icon.svg"}
                            style={{ width: "90px" }}
                        />
                    </div>
                    {/* <span style={{ padding: "4px 0", color: "rgb(137, 137, 137)" }}>
                        30
                    </span> */}
                    {/* <span style={{ color: "rgb(137, 137, 137)" }}>{level}</span> */}
                </div>

                {/* CENTER PROGRESS */}
                <div className="MuiGrid-root styles_progressRank_center__2w2gF MuiGrid-item MuiGrid-grid-md-8-t ">
                    <div className="MuiBox-root css-79elbk">
                        <div className="MuiLinearProgress-root MuiLinearProgress-colorPrimary jss44 jss45 MuiLinearProgress-determinate">
                            <div
                                className="MuiLinearProgress-bar MuiLinearProgress-barColorPrimary MuiLinearProgress-bar1Determinate"
                                style={{ transform: progressTransform }}
                            />
                        </div>
                        <div className="MuiBox-root css-1o8dslu">
                            <div className="MuiBox-root css-0 flex justify-center" style={{ position: "absolute", zIndex: 100, top: "-30px", transform: "translateX(-50%)", backgroundColor: "transparent", minWidth: "68px", left: markerLeft }}>
                                <p className="MuiTypography-root styles_progressLabel__v9DSE MuiTypography-body1" style={{ transform: "translateX(0%)" }}>{pointTotal.toLocaleString('vi-VN')}
                                    <span style={{ fontFamily: "ggsr", fontSize: "14px", marginLeft: "4px" }}> điểm</span>
                                </p>
                                <div className="styles_arrowIcon__Krh3o MuiBox-root css-0">
                                    <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.4641 0L6.9282 6H0L3.4641 0Z" fill="var(--primary-color)"></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* RIGHT RANK */}
                {nextLevel && (
                    <div className="MuiGrid-root styles_progressRank_right__wIRU1 MuiGrid-item MuiGrid-grid-md-2">

                        <div className="flex justify-center">
                            <img
                                alt="icon rank"
                                src={nextLevelImage || "https://cdn-web-next.thuocsi.vn/images/userLoyalty/rank_gold_icon.svg"}
                                style={{ width: "32px" }}
                            />
                        </div>

                        <span style={{ padding: "4px 0", color: "rgb(169, 91, 63)" }}>
                            80
                        </span>
                        <span style={{ color: "rgb(169, 91, 63)" }}>{nextLevel}</span>
                    </div>
                )
                }
            </div>
        </div>
    );
}
